import styled from "styled-components";

export const ContactSection = styled.section`
    margin-bottom: 3rem;
    margin-top: 5rem;
    .container {
        .button {
            margin-left: auto;
        }
    }
`;

export const FormErrorMessage = styled.div`
    color: ${props => props.theme.palette.error.contrastText};
    background: ${props => props.theme.palette.error.main};
    padding: 0.875rem;
    margin-bottom: 1.375rem;
    margin-top: 3.125rem;
    display: flex;
    align-items: center;
`;
